<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          証明書発行申請一覧
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <v-autocomplete
          v-model="titleFilterValue"
          label="証明書名称"
          placeholder="証明書名称"
          :items="titleList"
          item-text="name"
          item-value="code"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" xl="2">
        <v-autocomplete
          v-model="filterStatus"
          label="処理状況"
          placeholder="処理状況"
          :items="statusList"
          item-text="name"
          item-value="code"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" xl="2">
        <ValidationProvider name="申請日from" rules="required" v-slot="{ errors }">
          <v-text-field
              v-model="fromDate"
              label="申請日from"
              placeholder=""
              :error-messages="errors[0]"
              type="date"
              outlined
              dense
              hide-details="auto"
              background-color="white"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" xl="2">
        <ValidationProvider name="申請日to" rules="required" v-slot="{ errors }">
          <v-text-field
              v-model="toDate"
              label="申請日to"
              placeholder=""
              :error-messages="errors[0]"
              type="date"
              outlined
              dense
              hide-details="auto"
              background-color="white"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <v-row dense v-if="teacherFlg">
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <v-select
          label="課程"
          :items="kateiMst"
          @change="changeKBK"
          item-text="name"
          item-value="code"
          v-model="selectedKatei"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" xl="2">
        <v-select
          label="部"
          :items="buMst"
          @change="changeKBK"
          item-text="name"
          item-value="code"
          v-model="selectedBu"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <v-select
          label="科"
          :items="kaMst"
          @change="changeKBK"
          item-text="name"
          item-value="code"
          v-model="selectedKa"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" xl="2">
        <v-select
          label="学年"
          :items="gakunenMst"
          item-text="name"
          item-value="code"
          v-model="selectedGakunen"
          outlined
          dense
          clearable
          multiple
          chips
          deletable-chips
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" xl="2">
        <v-select
          label="学級"
          :items="gakkyuMst"
          item-text="name"
          item-value="code"
          v-model="selectedGakkyu"
          outlined
          dense
          clearable
          multiple
          chips
          deletable-chips
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <v-autocomplete
          v-model="filterRequestUser"
          label="申請者氏名"
          placeholder="申請者氏名"
          :items="requestUserList"
          item-text="name"
          item-value="code"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col class="d-flex justify-end" cols="12" sm="9" md="9" lg="9" xl="9">
        <v-btn v-if="openRequestBtn" color="accent" class="ma-2 black--text" @click="certificateModalFlg = true">
          新規申請
        </v-btn>
        <v-btn v-if="openExcelBtn" :disabled="isExportingFlg" color="green" class="ma-2 black--text" @click="exportSchoolReportExcel">
          調査書Excel出力
        </v-btn>  
        <v-btn v-if="openExcelBtn" :disabled="isExportingFlg" color="green" class="ma-2 black--text" @click="exportExcel">
          Excel出力
        </v-btn>      
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="filteredRequests"
          :items-per-page.sync="perPage"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          @click:row="onClickCertificateRequest"
          :loading="isLoading" loading-text="読込中"
        >
          <!-- 証明書名称(ヘッダー) -->
          <template #[`header.certificateName`]="{}"> 
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                名称
              </v-col>
            </v-row>
          </template>

          <!-- 申請日時/申請者(ヘッダー) -->
          <template #[`header.requestUserNm`]="{}"> 
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                申請日時
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                申請者
              </v-col>
            </v-row>
          </template>

          <!-- 課程部科/学年学級出席番号/学籍番号(ヘッダー) -->
          <template #[`header.gakusekiCd`]="{}"> 
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                課程/部/科
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                学年/学級/出席番号
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                学籍番号
              </v-col>
            </v-row>
          </template>

          <!-- 処理状況(ヘッダー) -->
          <template #[`header.statusNm`]="{}"> 
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                処理状況
              </v-col>
            </v-row>
          </template>

          <!-- 証明書名称 -->
          <template #[`item.certificateName`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                {{ item.certificateName }}
              </v-col>
            </v-row>
          </template>

          <!-- 申請日時/申請者 -->
          <template #[`item.requestUserNm`]="{ item }">
            <v-row dense class="my-0">
              <v-col cols="12" class="d-flex justify-start py-0">
                <span style="white-space : nowrap;">{{ item.insDate }}</span>
              </v-col>
            </v-row>
            <v-row dense class="my-0">
              <v-col cols="12" class="d-flex justify-start py-0">
                <span style="white-space : nowrap;">{{ item.requestUserNm }}</span>
              </v-col>
            </v-row>
            <v-row dense class="my-0" v-if="item.requestUserId != item.createUserId">
              <v-col cols="12" class="d-flex justify-start py-0">
                <span style="white-space : nowrap;">{{ '<申請>' + item.createUserNm }}</span>
              </v-col>
            </v-row>
          </template>

          <!-- 課程部科/学年学級出席番号/学籍番号 -->
          <template #[`item.gakusekiCd`]="{ item }">
            <v-row dense class="my-0">
              <v-col cols="12" justify="center" class="py-0">
                {{ item.kateiNm }}/{{ item.buNm }}/{{ item.kaNm }}
              </v-col>
            </v-row>
            <v-row dense class="my-0">
              <v-col cols="12" justify="center" class="py-0">
                {{ item.gakunen }}/{{ item.gakkyu }}/{{ item.syussekiNo }}
              </v-col>
            </v-row>
            <v-row dense class="my-0">
              <v-col cols="12" justify="center" class="py-0">
                {{ item.gakusekiCd }}
              </v-col>
            </v-row>
          </template>

          <!-- 処理状況 -->
          <template #[`item.statusNm`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center" :class="{'red--text': item.status == '0',}">
                {{ item.statusNm }}
              </v-col>
            </v-row>
          </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

    <!-- 申請書選択モーダル -->
    <v-dialog
      v-model="certificateModalFlg"
      max-width="700"
      min-height="260"
      max-height="260"
      persistent
      scrollable
    >
      <v-card
          class="d-flex flex-column mx-auto my-auto flat"
          color="#fff"
          min-height="260"
        >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="certificateModalFlg = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              証明書発行申請（申請フォーム選択）
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
          <ValidationProvider name="ラジオ" rules="required" v-slot="{ errors }" v-model="createStudent" :skipIfEmpty="false">
            <v-radio-group 
              v-model="createStudent"
              :error-messages="errors[0]"
              hide-details="auto"
              class="mt-3"
            >
              <v-row dense v-for="student in studentInfo" :key="student.loginId" class="mx-3 my-0">
                <v-col cols="12" class="py-0">
                  <v-radio 
                    class="mb-5 mr-5"
                    :label="student.userNmLabel"
                    :value="student.loginId"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </ValidationProvider>
          <v-data-table
            :headers="certificateTemplateHeaders"
            :items="certificateList"
            :items-per-page="10"
            dense
            disable-sort
            >

            <template #[`item.title`]="{ item }">
              <v-row dense><v-col cols="12" justify="center">{{ item.title }}</v-col></v-row>
            </template>

            <template #[`item.request`]="{ item }">
              <v-row dense>
                <v-col cols="12" justify="center">
                  <v-btn color="accent" class="ma-2 black--text" @click="createCertificateRequest(item)" :disabled="invalid">
                    申請する
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import Enumerable from "linq";
import { parse, endOfDay } from 'date-fns';
import { ja } from 'date-fns/locale';
import { saveAsCommon } from '../../common';
export default {
  computed: {
    filteredRequests() {
      // 申請一覧のフィルタ
      const fromDate = parse(this.fromDate, 'yyyy-MM-dd', new Date());
      const toDate = endOfDay(parse(this.toDate, 'yyyy-MM-dd', new Date()));
      return this.requests.filter(r => {
        // 証明書名称
        const certificateIdMatch = (!this.titleFilterValue || this.titleFilterValue == r.certificateId);

        // 処理状況
        const statusMatch = (!this.filterStatus || this.filterStatus == r.status);

        // 処理状況
        const userMatch = (!this.filterRequestUser || this.filterRequestUser == r.requestUserId);

        // 申請日FromTo
        const requestDate = parse(r.insDate, 'yyyy年M月d日(E) HH:mm', new Date(), { locale: ja });
        const dateMatch = (fromDate.getTime() <= requestDate && requestDate <= toDate.getTime());

        let kateiMatch = true;
        if(this.selectedKatei && r.kateiCd) {
          kateiMatch = (this.selectedKatei == r.kateiCd);
        }
        let buMatch = true;
        if(this.selectedBu && r.buCd) {
          buMatch = (this.selectedBu == r.buCd);
        }
        let kaMatch = true;
        if(this.selectedKa && r.kaCd) {
          kaMatch = (this.selectedKa == r.kaCd);
        }
        let gakunenMatch = true;
        if(this.selectedGakunen.length > 0 && r.gakunenCd) {
          let gakunenCd = [];
          for (let i=0; i<this.selectedGakunen.length; i++) {
            gakunenCd.push(this.selectedGakunen[i].split("-")[3]);
          }
          gakunenMatch = gakunenCd.includes(r.gakunenCd);
        }
        let gakkyuMatch = true;
        if(this.selectedGakkyu.length > 0 && r.gakkyuCd) {
          let gakkyuCd = [];
          for (let j=0; j<this.selectedGakkyu.length; j++) {
            gakkyuCd.push(this.selectedGakkyu[j].split("-")[3]);
          }
          gakkyuMatch = gakkyuCd.includes(r.gakkyuCd);
        }

        return kateiMatch && buMatch && kaMatch && gakunenMatch && gakkyuMatch 
          && certificateIdMatch && statusMatch && dateMatch && userMatch;
      })
    },
  },
  data() {
    return {
      kateiMst: [],
      buMst: [],
      kaMst: [],
      gakunenMst: [],
      gakunenMstBase: [],
      gakkyuMst: [],
      gakkyuMstBase: [],
      selectedKatei: "",
      selectedBu: "",
      selectedKa: "",
      selectedGakunen: [],
      selectedGakkyu: [],
      // 証明書フィルタ
      titleFilterValue: "",
      titleList : [],
      // 申請者フィルタ
      filterRequestUser: "",
      requestUserList : [],
      // 処理状況フィルタ
      filterStatus : "",
      statusList : [],
      tounendo: "",
      fromDate: "",
      toDate: "",
      headers : [
        { text: "", value: "certificateName" , width: "40%" },
        { text: "", value: "requestUserNm", width: "30%" },
        { text: "", value: "gakusekiCd" , width: "20%" }, 
        { text: "", value: "statusNm", width: "10%" },
      ],
      requests: [],
      isLoading: false,
      perPage: 30,
      // 新規申請ダイアログ
      certificateModalFlg: false,

      // 証明書一覧
      certificateList: [],
      certificateTemplateHeaders: [
        { text: "名称", value: "title" , width: "70%" },
        { text: "", value: "request" , width: "30%" },
      ],

      // 新規申請の対象生徒
      studentInfo : [],
      createStudent : null,

      // ボタン表示
      openRequestBtn : false,
      openExcelBtn : false,

      // 教員ユーザフラグ
      teacherFlg : false,
      
      isExportingFlg : false,

      filteredRequestsList : []
    };
  },
  // 初期表示時データ読み込み
  async created() {
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");

    // 新規申請用の証明書一覧の取得
    await schoolAidHomeLogined({funcName: "loadCertificateList"}).then((ret) => {
      this.certificateList = ret.data.certificates;
      this.teacherFlg = ret.data.teacherFlg;
    });

    if (this.teacherFlg) {
      // 課程・部・科・学年・学級の取得
      schoolAidHomeLogined({funcName: "commonGetKBKG"}).then((ret) => {
        this.kateiMst = ret.data.kateiMst;
        this.buMst = ret.data.buMst;
        this.kaMst = ret.data.kaMst;
        this.gakunenMstBase = ret.data.gakunenMst;
        this.gakkyuMstBase = ret.data.gakkyuMst;
        // 取得データ１件だけなら初期値に設定
        if (this.kateiMst.length == 1) {
          this.selectedKatei = this.kateiMst[0].code;
        }
        if (this.buMst.length == 1) {
          this.selectedBu = this.buMst[0].code;
        }
        if (this.kaMst.length == 1) {
          this.selectedKa = this.kaMst[0].code;
        }
      });
    }

    // 新規申請ボタンとExcel出力ボタンの表示制御
    if (!this.teacherFlg) this.openRequestBtn = true;
    if (this.teacherFlg) this.openExcelBtn = true;

    this.perPage = this.$store.state.parPageCertificateRequestList;

    await this.reload();
  },
  watch: {
    perPage: function(newVal) {
      this.$store.dispatch('setParPageCertificateRequestList', newVal);
    },
  },
  methods: {
		async changeKBK() {
      this.gakunenMst = [];
      this.gakkyuMst = [];
      this.selectedGakkyu = [];
      this.selectedGakunen = [];
      if(this.selectedKatei
       && this.selectedBu
       && this.selectedKa){
        // 学年マスタをKBKでフィルタ
        this.gakunenMst = Enumerable.from(this.gakunenMstBase).where(i => 
        i.code.substring(0, 8) == (
          this.selectedKatei
          + "-"
          + this.selectedBu
          + "-"
          + this.selectedKa
          )).toArray();
        // 学級マスタをKBKでフィルタ
        this.gakkyuMst = Enumerable.from(this.gakkyuMstBase).where(i => 
        i.code.substring(0, 8) == (
          this.selectedKatei
          + "-"
          + this.selectedBu
          + "-"
          + this.selectedKa
          )).toArray();
      }
    },
    // 申請日FromToの初期値設定
    defaultDateSet() {
      const dt = new Date();
      const yyyyTo = dt.getFullYear();
      const mmTo = ('00' + (dt.getMonth()+1)).slice(-2);
      const ddTo = ('00' + dt.getDate()).slice(-2);
      this.toDate = (yyyyTo + '-' + mmTo + '-' + ddTo);
      this.fromDate = (this.tounendo + '-04-01');
    },
    async reload() {
      this.requests = [];
      // 検索条件格納用配列
      const temp_titles = new Map();
      const temp_status = new Map();
      const temp_users = new Map();
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isLoading = true;
      const param = {
        funcName:"loadCertificateRequestList",
      }
      await schoolAidHomeLogined(param).then((res) => {
        let ret = [];
        res.data.requests.forEach((recode) => {
          // 検索条件を追加する
          temp_titles.set(recode.certificateId, {
            code: recode.certificateId,
            name: recode.certificateName
          });
          temp_status.set(recode.status, {
            code: recode.status,
            name: recode.statusNm
          });
          temp_users.set(recode.requestUserId, {
            code: recode.requestUserId,
            name: recode.requestUserNm
          });
          const row = {
            certificateId: recode.certificateId,
            certificateName: recode.certificateName,
            publishFlg: recode.publishFlg,
            requestId: recode.requestId,
            requestUserId: recode.requestUserId,
            requestUserNm: recode.requestUserNm,
            requestType: recode.requestType,
            createUserId: recode.createUserId,
            createUserNm: recode.createUserNm,
            insDate: recode.insDate,
            kateiCd: recode.kateiCd,
            buCd: recode.buCd,
            kaCd: recode.kaCd,
            gakunenCd: recode.gakunenCd,
            gakunen: recode.gakunen,
            gakkyuCd: recode.gakkyuCd,
            gakkyu: recode.gakkyu,
            syussekiNo: recode.syussekiNo,
            gakusekiCd: recode.gakusekiCd,
            kateiNm: recode.kateiNm,
            buNm: recode.buNm,
            kaNm: recode.kaNm,
            status: recode.status,
            statusNm: recode.statusNm,
          };
          ret.push(row);
        });
        this.requests = ret;
        this.tounendo = res.data.tounendo;
        this.studentInfo = res.data.studentInfo;
        this.isLoading = false;
      });
      this.titleList = Array.from(temp_titles.values());
      this.statusList = Array.from(temp_status.values());
      this.requestUserList = Array.from(temp_users.values());
      // 申請対象生徒が１件だけなら初期値選択
      if (this.studentInfo.length == 1) this.createStudent = this.studentInfo[0].loginId;
      this.defaultDateSet();
    },
    // 個別連絡画面へ
    createCertificateRequest(item) {
      // 証明書か調査書かで遷移先を分岐させる
      if (item.requestType === 'certificate') {
        this.$router.push({
          name: "CertificateRequestDetail",
          params: {
            certificateId : item.certificateId,
            requestId: "",
            requestUserId: this.createStudent,
            certificateIdBuff: [],
            requestIdBuff: [],
            requestUserIdBuff: [],
            requestListIndex: 0,
          } 
        });
      } else if (item.requestType === 'schoolReport') {
        this.$router.push({
          name: "SchoolReportRequestDetail",
          params: {
            schoolReportId : item.certificateId,
            requestId: "",
            requestUserId: this.createStudent,
            schoolReportIdBuff: [],
            requestIdBuff: [],
            requestUserIdBuff: [],
            requestListIndex: 0,
          } 
        });
      }
    },
    // 個別連絡画面へ
    onClickCertificateRequest(item) {
      if (item.requestType === 'certificate') {
        this.filteredRequestsList = this.requests.filter(value => value.requestType === 'certificate')
        const certificateIdBuff = Enumerable.from(this.filteredRequestsList).select(x => { return x.certificateId }).toArray();
        const requestIdBuff = Enumerable.from(this.filteredRequestsList).select(x => { return x.requestId }).toArray();
        const requestUserIdBuff = Enumerable.from(this.filteredRequestsList).select(x => { return x.requestUserId }).toArray();
        const requestListIndex = requestIdBuff.indexOf(item.requestId);
        this.$router.push({
          name: "CertificateRequestDetail",
          params: {
            certificateId : item.certificateId,
            requestId: item.requestId,
            requestUserId: item.requestUserId,
            certificateIdBuff: certificateIdBuff,
            requestIdBuff: requestIdBuff,
            requestUserIdBuff: requestUserIdBuff,
            requestListIndex: requestListIndex,
          } 
        });
      } else if (item.requestType === 'schoolReport') {
        this.filteredRequestsList = this.requests.filter(value => value.requestType === 'schoolReport')
        const schoolReportIdBuff = Enumerable.from(this.filteredRequestsList).select(x => { return x.certificateId }).toArray();
        const requestIdBuff = Enumerable.from(this.filteredRequestsList).select(x => { return x.requestId }).toArray();
        const requestUserIdBuff = Enumerable.from(this.filteredRequestsList).select(x => { return x.requestUserId }).toArray();
        const requestListIndex = requestIdBuff.indexOf(item.requestId);
        this.$router.push({
          name: "SchoolReportRequestDetail",
          params: {
            schoolReportId : item.certificateId,
            requestId: item.requestId,
            requestUserId: item.requestUserId,
            schoolReportIdBuff: schoolReportIdBuff,
            requestIdBuff: requestIdBuff,
            requestUserIdBuff: requestUserIdBuff,
            requestListIndex: requestListIndex,
          } 
        });
      }
    },
    // 調査書Excel出力処理（現在フィルタされたデータを対象に出力）
    async exportSchoolReportExcel() {
      this.filteredRequestsList = this.filteredRequests.filter(item => item.requestType === 'schoolReport');
      if (this.filteredRequests.length == 0) {
        alert("出力対象が選択されていません。");
        return;
      }
      
      const result = confirm("出力してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.isExportingFlg = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const param = {
        funcName: "exportExcelSchoolReport",
        requests: this.filteredRequestsList,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data.message){
          alert(ret.data.message);
        } else {
          saveAsCommon(ret.data.downloadUrl, ret.data.fileName);
          alert("ダウンロードを開始します。\nダウンロードフォルダをご確認ください。\n※ファイルを確認出来ない場合はポップアップがブロックされていないか\nご確認ください。");
        }
      });
      // ローディング終了
      this.isExportingFlg = false;
    },

    // Excel出力処理（現在フィルタされたデータを対象に出力）
    async exportExcel() {
      this.filteredRequestsList = this.filteredRequests.filter(item => item.requestType === 'certificate');
      if (this.filteredRequests.length == 0) {
        alert("出力対象が選択されていません。");
        return;
      }
      
      const result = confirm("出力してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.isExportingFlg = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const param = {
        funcName: "exportExcelCertificateReport",
        requests: this.filteredRequestsList,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data.message){
          alert(ret.data.message);
        } else {
          saveAsCommon(ret.data.downloadUrl, ret.data.fileName);
          alert("ダウンロードを開始します。\nダウンロードフォルダをご確認ください。\n※ファイルを確認出来ない場合はポップアップがブロックされていないか\nご確認ください。");
        }
      });
      // ローディング終了
      this.isExportingFlg = false;
    },
  },
};
</script>

<style scoped>

</style>